export default __webpack_public_path__ + "static/media/Statistik Lengkap UTBK STEI-K222.d3f2e5f0.png";